import { useAuth0 } from "@auth0/auth0-react";
import { Container, TextField, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import React, { useContext } from "react";
import { OrganisationContext, OrganisationSignalRContext } from "../../context/OrganisationContext";
import { CreateOrganisationModel } from "../../models/OrganisationModels";
import { useAppInsights } from "../../services/appInsights";
import { TelemetryEvents } from "../../telemetry/eventNames";
import { TelemetryProp, toTelemetryProps } from "../../telemetry/telemetryProps";
import { TelemetrySurface } from "../../telemetry/surfaces";
import { ChasableSignalRContext } from "../../context/ChasablesContext";

const CreateOrganisation = () => {
  const { trackEvent } = useAppInsights();
  const { logout } = useAuth0();
  const [isLoading, setIsLoading] = React.useState(false);
  const { createOrganisation } = useContext(OrganisationContext);
  const [form, setForm] = React.useState<CreateOrganisationModel>({
    organisation: {
      name: "",
    },
    user: {
      firstName: "",
      lastName: "",
      position: "",
    },
  });

  React.useEffect(() => {
    trackEvent({
      name: TelemetryEvents.userLoggedInWithoutOrganisation,
      properties: toTelemetryProps({ [TelemetryProp.surface]: TelemetrySurface.organisation }),
    });
  }, [trackEvent]);

  const handleCreateOrganisation = async () => {
    setIsLoading(true);
    try {
      const response = await createOrganisation(form);
      if (response) {
        // Redirect user
      } else {
        // Handle error
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSignout = async () => {
    try {
      await Promise.all([ChasableSignalRContext.connection?.stop(), OrganisationSignalRContext.connection?.stop()]);
      await logout({ logoutParams: { returnTo: `${window.location.origin}/taskpane.html` } });
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <Container>
      <Stack justifyContent="center" alignItems="center" height="100%">
        <Typography component="h1" variant="subtitle1">
          Welcome to Attelas!
        </Typography>
        <Typography>To get started, we need a bit more information from you.</Typography>
        <TextField
          type="text"
          value={form.user.firstName}
          onChange={(e) => setForm({ ...form, user: { ...form.user, firstName: e.target.value } })}
          label="First name"
          variant="outlined"
          required
          sx={{ mt: 2 }}
          fullWidth
        />
        <TextField
          type="text"
          label="Last name"
          value={form.user.lastName}
          onChange={(e) => setForm({ ...form, user: { ...form.user, lastName: e.target.value } })}
          variant="outlined"
          sx={{ mt: 2 }}
          required
          fullWidth
        />
        <TextField
          type="text"
          label="Job title"
          value={form.user.position}
          onChange={(e) => setForm({ ...form, user: { ...form.user, position: e.target.value } })}
          variant="outlined"
          sx={{ mt: 2 }}
          required
          fullWidth
        />
        <TextField
          type="text"
          label="Organisation Name"
          value={form.organisation.name}
          onChange={(e) => setForm({ ...form, organisation: { ...form.organisation, name: e.target.value } })}
          variant="outlined"
          sx={{ mt: 2 }}
          required
          fullWidth
        />
        <Button
          variant="contained"
          color="primary"
          disabled={isLoading}
          onClick={handleCreateOrganisation}
          sx={{ mt: 2 }}
          fullWidth
        >
          Continue
        </Button>
        <Button variant="text" onClick={handleSignout} color="primary" sx={{ mt: 2 }}>
          Sign out
        </Button>
      </Stack>
    </Container>
  );
};

export default CreateOrganisation;
